import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { RegistrationService } from "./registration.service";
import { Router } from "@angular/router";
import { RegistrationModel } from "./registration.models";
import { Error } from "@bt/shared";
import { Validators, EmailValidator, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from 'angular-notifier';

library.add(fas, far);
library.add(faCheckCircle);
library.add(faTimesCircle);

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ["./registration.component.scss"]
})
export class RegistrationComponent extends BaseComponent {

  public regForm: FormGroup;
  public isSubmitted: boolean = false;
  public emailModel: any;
  public passwordModel: any;
  public textError: string;
  public regModel: RegistrationModel;

  constructor(private service: RegistrationService,
    private router: Router,
    private fb: FormBuilder,
    private notifier: NotifierService) {
    super();

  }

  public register() {
    var t = this;
    if (!t.regForm.valid) {
      t.textError = "Проверьте корректность введённых данных";
      var alert = document.getElementsByClassName("myalert");
      (<any>alert[0]).style.display = "block";
      setTimeout(function () { (<any>alert[0]).style.display = "none"; }, 4000)
      return;
    }
    t.setLoading(true);

    if(!(localStorage.getItem("refLink") === 'A')){
      t.regModel.ref = localStorage.getItem("refLink");
    } 

    t.service
      .register(t.regModel)
      .subscribe(
        (response) => {
          localStorage.setItem("activationSessionId", response.data.sessionId);
          t.notifier.notify('success', 'Успешная регистрация, на вашу почту отправлено письмо');
          t.router.navigateByUrl("app/login");
          t.setLoading(false);
        },
        (error: HttpErrorResponse) => {
          t.textError = error.error.errorMsgs[0];
          if(t.textError=="Password and password confirmation not equal")
          {
            t.textError = "Пароль и подтверждение пароля не равны";
          }
          else if("User with the same email already exists"){
            t.textError = "Пользователь с таким email уже существует";
          }
          var alert = document.getElementsByClassName("myalert");
          (<any>alert[0]).style.display = "block";
          setTimeout(function () { (<any>alert[0]).style.display = "none"; }, 4000)
          t.setLoading(false);

        }
      );

  }


  get email() { return this.regForm.get('email'); }
  get password() { return this.regForm.get('password'); }
  get confirmPassword() { return this.regForm.get('confirmPassword'); }

  public ngOnInit() {
    this.regModel = new RegistrationModel();
    this.regForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],//Validators.pattern(this.emailPattern)
      password: ["", [Validators.required, Validators.minLength(8)]],
      confirmPassword: ["", [Validators.required, Validators.minLength(8)]]
    },
    {
      validator: this.passwordMatchValidator
    });

    // this.regForm.valueChanges
    //   .filter(() => !!this.error)
    //   .forEach(() => {
    //     this.clearError();
    //   });
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('password').value === g.get('confirmPassword').value
       ? null : { 'mismatch': true };
   }
}



// WEBPACK FOOTER //
// ./src/app/public/registration/registration.component.ts